export var LinkValidationResponse;
(function (LinkValidationResponse) {
    /**
     * The validation status of the charger asset link.
     */
    let linkStatus;
    (function (linkStatus) {
        linkStatus["DEACTIVATED"] = "DEACTIVATED";
        linkStatus["EXPIRED"] = "EXPIRED";
        linkStatus["ACTIVE"] = "ACTIVE";
    })(linkStatus = LinkValidationResponse.linkStatus || (LinkValidationResponse.linkStatus = {}));
})(LinkValidationResponse || (LinkValidationResponse = {}));
